import getTag from './internals/getTag.js';
import { fileTag, stringUndefined } from './internals/native.js';

var fileExisted = typeof File !== stringUndefined;
function isFile(value) {
    if (fileExisted && value instanceof File) {
        return true;
    }
    return getTag(value) === fileTag;
}

export { isFile as default };
